import { render, staticRenderFns } from "./SuccessBox.vue?vue&type=template&id=ab42b1be&scoped=true&"
import script from "./SuccessBox.vue?vue&type=script&lang=js&"
export * from "./SuccessBox.vue?vue&type=script&lang=js&"
import style0 from "./SuccessBox.vue?vue&type=style&index=0&id=ab42b1be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab42b1be",
  null
  
)

export default component.exports